import React, { createContext, useContext, useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './lib/supabase'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import Session from './pages/Session'
import Community from './pages/Community'
import Stats from './pages/Stats'
import Notifications from './pages/Notifications'
import Profile from './pages/Profile'
import Auth from './pages/Auth'
import ResetPassword from './pages/ResetPassword'
import './App.css'

export const AuthContext = createContext(null)
export const useAuth = () => useContext(AuthContext)

export default function App() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'INITIAL_SESSION') {
        if (session?.user) {
          const { data } = await supabase.from('profiles').select('*').eq('id', session.user.id).single()
          if (data) setUser(data)
        }
        setLoading(false)
      } else if (event === 'SIGNED_IN' && session?.user) {
        const { data } = await supabase.from('profiles').select('*').eq('id', session.user.id).single()
        if (data) setUser(data)
      } else if (event === 'SIGNED_OUT') {
        setUser(null)
      }
    })

    return () => subscription.unsubscribe()
  }, [])

  if (loading) return <div className="app-loading"><div className="loading-note">🎵</div></div>

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      <BrowserRouter>
        <Routes>
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth" element={!user ? <Auth /> : <Navigate to="/" />} />
          <Route path="/" element={user ? <Layout /> : <Navigate to="/auth" />}>
            <Route index element={<Home />} />
            <Route path="session" element={<Session />} />
            <Route path="community" element={<Community />} />
            <Route path="stats" element={<Stats />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  )
}
